import React, { Component } from 'react';
import './button.css';

class Button extends Component {
  render() {
    const { changePage, pageName } = this.props;

    return (
      <div className={"hover-button " + this.props.containerClassName} onClick={() => changePage(pageName)}>
        <img className={"hover-button-svg " + this.props.innerClassName} src={this.props.buttonFile} alt={this.props.caption} />
        <div className="hover-button-text">{this.props.caption}</div>
      </div>
    );
  }
}

export default Button;
